import React from "react";
import { useSelector } from "react-redux";
// import "./SharedDiv.css";

export default function SharedDiv(props) {
  const JsonDataa = useSelector((state) => state.FetchDataJson);

  return (
    /* 
    props
    showTitle = true , false
    titleNameAR = ""
    titleNameEN=""
    child = [component structure]
    redboxshadow = true , false
    
    */

    <div
      className={`container ${
        props.redboxshadow ? "red-box-shadow" : "container"
      }`}
    >
      <div className="Subcontainer">
        {props.showTitle && (
          <div
            className="title-container"
            title={props.lang == "ar" ? props.titleNameEN : props.titleNameAR}
          >
            <p className="title tilteWithBtn " id={props.id_Title}>
              <div>
                {props.lang !== "en" ? props.titleNameAR : props.titleNameEN}
              </div>
              <div className="containerButtonTitle">
                {props.showButton && props.buttonComponent}
              </div>
            </p>
          </div>
        )}
        {props.child}
      </div>
    </div>
  );
}
